import { run } from './main.jsx';

run();
